import { createSelector, createStructuredSelector } from 'reselect';
import configObjectTypes from '../../constants/configObjectTypes';
import { values, flow, property, reduce } from 'lodash';

export const getAdminConfig = property('app.adminConfig');
const adminConfigMapper = createStructuredSelector({
  [configObjectTypes.link]: flow(getAdminConfig, (config) => config.get(configObjectTypes.link)),
  [configObjectTypes.modal]: flow(getAdminConfig, (config) => config.get(configObjectTypes.modal)),
  [configObjectTypes.bankImg]: flow(getAdminConfig, (config) =>
    config.get(configObjectTypes.bankImg),
  ),
  [configObjectTypes.situations]: flow(getAdminConfig, (config) =>
    config.get(configObjectTypes.situations),
  ),
});

export const adminConfigSelector = createSelector([adminConfigMapper], (configs) =>
  reduce(values(configObjectTypes), (result, type) => ({ ...result, ...configs[type] }), {}),
);
